/** Session cache key for the superadmin dashboard snapshot (see superAdminDashboardUtils). */
export const SA_DASHBOARD_CACHE_KEY = "reimagine_sa_dashboard_v1";

/** Drops the cached dashboard so the next visit reloads counts after data was created/changed/deleted. */
export function invalidateSuperAdminDashboardCache(): void {
  try {
    sessionStorage.removeItem(SA_DASHBOARD_CACHE_KEY);
  } catch {
    // ignore private mode / blocked storage
  }
}
